// src/systems/dialogueSystem.ts — Cola de diálogos (Fase 2)
export type DialogueEntry = { speaker: string; lines: string[] };

export class DialogueSystem {
  private queue: DialogueEntry[] = [];
  private lineIdx = 0;
  private charIdx = 0;
  private active: DialogueEntry | null = null;
  private finished = false;
  private speed: 'lenta'|'normal'|'rapida' = 'normal';

  setSpeed(s: 'lenta'|'normal'|'rapida'): void { this.speed = s; }

  start(entries: DialogueEntry[]): void {
    this.queue = [...entries]; this.lineIdx=0; this.charIdx=0; this.finished=false;
    this.active = this.queue.shift() ?? null;
  }

  isActive(): boolean { return this.active !== null; }
  isFinished(): boolean { return this.finished && !this.isActive(); }

  getSpeaker(): string { return this.active?.speaker ?? ''; }
  getCurrentLine(): string { return this.active?.lines[this.lineIdx] ?? ''; }

  // typewriter: devuelve texto progresivo
  getVisibleText(): string {
    const line = this.getCurrentLine();
    return line.slice(0, this.charIdx);
  }
  isLineFullyVisible(): boolean {
    return this.charIdx >= this.getCurrentLine().length;
  }

  // avanzar typewriter por frame
  tickTypewriter(dt: number): void {
    if (!this.active) return;
    if (this.isLineFullyVisible()) return;
    const cps = this.speed==='lenta'? 22 : this.speed==='rapida'? 55 : 36;
    this.charIdx = Math.min(this.getCurrentLine().length, this.charIdx + dt*cps);
  }

  // input: avanzar línea o entrada
  advance(): boolean {
    if (!this.active) return false;
    if (!this.isLineFullyVisible()){
      this.charIdx = this.getCurrentLine().length; // revelar todo
      return true;
    }
    if (this.lineIdx < this.active.lines.length -1){
      this.lineIdx++; this.charIdx=0; return true;
    }
    // siguiente entrada
    this.active = this.queue.shift() ?? null;
    this.lineIdx=0; this.charIdx=0;
    if (!this.active) this.finished=true;
    return true;
  }

  close(): void { this.active=null; this.queue=[]; this.finished=false; }
}
